import { useState, useEffect, useRef, useCallback } from 'react';
const useDismissal = (autoDismiss, autoDismissDelay, onDismiss) => {
    const delay = autoDismissDelay === 'short' ? 4000 : autoDismissDelay === 'long' ? 10000 : 7000;
    const [isOpen, setOpen] = useState(true);
    const autoDismissTimeout = useRef();
    const handleDismiss = useCallback(() => {
        autoDismissTimeout.current && window.clearTimeout(autoDismissTimeout.current);
        setOpen(false);
        onDismiss && onDismiss();
    }, [onDismiss]);
    useEffect(() => {
        if (autoDismiss) {
            autoDismissTimeout.current = window.setTimeout(handleDismiss, delay);
        }
        return () => {
            autoDismissTimeout.current && window.clearTimeout(autoDismissTimeout.current);
        };
    }, [autoDismiss, delay, handleDismiss]);
    return [isOpen, handleDismiss];
};
export default useDismissal;
//# sourceMappingURL=useDismissal.js.map